import { atom } from 'jotai';
import type { LandXMLCategory, LandXMLFeatureMetadata } from '@/core/landxml';

/**
 * Snapshot of a clicked LandXML feature, exposed to the properties drawer.
 * `clickPoint` is the world-space hit position so the drawer can derive
 * station-along-alignment for ALIGNMENT picks.
 */
export interface SelectedLandXMLFeature {
  layerId: string;
  featureId: string;
  name: string;
  category: LandXMLCategory;
  metadata: LandXMLFeatureMetadata;
  clickPoint?: { x: number; y: number; z: number };
  /**
   * Set when the picked feature isn't itself an alignment but the layer
   * does have alignments — reports the closest one's station + offset so
   * the user can answer "where on the road is this point?".
   */
  nearestAlignment?: {
    name: string;
    featureId: string;
    station: number;
    offset: number;
  };
}

export const selectedLandXMLFeatureAtom = atom<SelectedLandXMLFeature | null>(null);
